export default __webpack_public_path__ + "static/media/g.0b9db522.jpg";